import BasicProfileURL from "@adapters/infrastructures/urlConfig/BasicProfile/BasicProfileConfigURL";
import clientDetailsMapper from "@domains/features/BasicProfile/Mapper/clientDetailsMapper";
import getRegisterdDevicMapper from "@domains/features/BasicProfile/useCases/getRegisteredDevicesMapper";
import { MandateURL } from "@adapters/infrastructures/urlConfig/Mandate/MandateUrl";
class BasicDetailsRepository {
    constructor(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    async getClientDetailsData() {
        const accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(BasicProfileURL.clientDetails);
        url.searchParams.append("accCode", accountCode);
        const AllClientDetails = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return clientDetailsMapper(AllClientDetails);
    }
    async advisorRatingDetailsData(req) {
        let accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(BasicProfileURL.advisorRating + accountCode);
        const AllAdvisorDetails = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req.body,
        });
        return AllAdvisorDetails.data;
    }
    async getDeviceRegisterDetailsData(req) {
        let prfid = req.prfId;
        const url = new URL(BasicProfileURL.getRegisteredDevices + "/" + prfid);
        const GetAllDevicesList = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return getRegisterdDevicMapper(GetAllDevicesList);
    }
    async getProfilePicData() {
        const accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(BasicProfileURL.getProfilePicture);
        url.searchParams.append("acCode", accountCode);
        const GetProfilePicDetails = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return GetProfilePicDetails.data;
    }
    async registerDeviceDetailsData(req) {
        const url = new URL(BasicProfileURL.deviceRegister);
        const RegisterDevicesList = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
        });
        return RegisterDevicesList.data;
    }
    async saveProfilePicData(req) {
        const url = new URL(BasicProfileURL.saveprofilepicture);
        const saveProfilePicDetails = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req.savepicbody,
        });
        return saveProfilePicDetails.data;
    }
    async deleteProfilePicData(req) {
        const url = new URL(BasicProfileURL.deleteProfilePicture);
        const deleteProfilePicDetails = await this.http.makeApiCall({
            method: "DELETE",
            url: url.toString(),
            body: req.savepicbody,
        });
        return deleteProfilePicDetails.data;
    }
    async deRegisterDeviceDetailsData(req) {
        const url = new URL(BasicProfileURL.deRegisterDevice);
        const DeregisterDevicesList = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
        });
        return DeregisterDevicesList.data;
    }
    async nomineeDetailsData(req) {
        let accTyp = await this.accountDetails.getAccTyp();
        const url = new URL(BasicProfileURL.nomineeDetails);
        url.searchParams.append("accTyp", accTyp);
        const NomineeDetails = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return NomineeDetails.data.value;
    }
    async getBrokerageSegmentData() {
        let accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(BasicProfileURL.getBrokerageSegments);
        url.searchParams.append("accCode", accountCode);
        const AllDetails = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return AllDetails.data;
    }
    async getRmDetailsData() {
        let accountCode = await this.accountDetails.getAccountCode();
        let accTyp = await this.accountDetails.getAccTyp();
        const url = new URL(BasicProfileURL.getRmDetails);
        url.searchParams.append("accCode", accountCode);
        url.searchParams.append("accType", accTyp);
        const AllRmDetails = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return AllRmDetails;
    }
    async whatsappContentDetailsData(req) {
        const url = new URL(BasicProfileURL.whatsappConsent);
        const WhatsappDetails = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
        });
        return WhatsappDetails.data;
    }
    async downloadKYC(req) {
        const url = new URL(BasicProfileURL.downloadKYCData);
        const result = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
        });
        return result;
    }
    async defaultExchangeData(req) {
        const url = new URL(BasicProfileURL.defaultExchange);
        const exchangedata = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
        });
        return exchangedata;
    }
    async wealthAdvisorData(req) {
        let accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(BasicProfileURL.wealthAdvisor);
        url.searchParams.append("accCode", accountCode);
        const wealthdata = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return wealthdata;
    }
    async saveLeadData(req) {
        const url = new URL(BasicProfileURL.savelead);
        const saveleaddata = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
        });
        return saveleaddata;
    }
    async mandateCalendarData(req) {
        let date = req.stDt;
        const url = new URL(MandateURL.mandateCalendar(req.userId, req.mandateId));
        url.searchParams.append("stDt", date);
        const mandateCalendardata = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return mandateCalendardata;
    }
    async deleteUpiData(req) {
        const url = new URL(BasicProfileURL.deleteUpi);
        const deleteUpiDetails = await this.http.makeApiCall({
            method: "DELETE",
            url: url.toString(),
            body: req,
        });
        return deleteUpiDetails.data;
    }
}
export default BasicDetailsRepository;
